export default "__VITE_ASSET___8NRgTVN__"